type Props = {
  features: string[] // Prop que contiene las características
}

export default function CarSpecialFeatures({ features }: Props) {
  return (
    <div>
      {/* Primera fila: los primeros cuatro elementos */}
      <div
        className={`
          flex flex-wrap items-center gap-1 overflow-hidden whitespace-nowrap
        `}
      >
        {features.slice(0, 4).map((text) => (
          <p
            className={`
              overflow-hidden text-ellipsis whitespace-nowrap rounded-sm border
              border-neutral-75 px-1 py-[5px] text-subtitle2-semibold
              text-neutral-500
            `}
            key={text}
          >
            {text}
          </p>
        ))}
      </div>
      {/* Segunda fila: elementos a partir del cuarto */}
      {features.length > 4 && (
        <div
          className={`
            mt-1 flex flex-wrap items-center gap-2 overflow-hidden
            whitespace-nowrap
          `}
        >
          {' '}
          {features.slice(4).map((text) => (
            <p
              className={`
                overflow-hidden text-ellipsis whitespace-nowrap rounded-sm
                border border-neutral-75 px-1 py-[5px] text-subtitle2-semibold
                text-neutral-500
              `}
              key={text}
            >
              {text}
            </p>
          ))}
        </div>
      )}
    </div>
  )
}
